<template xmlns="http://www.w3.org/1999/html">
  <div class="animated fadeIn" id="jira-worklogs">
    <div>
      <div class="card">
        <div class="card-block">
          <div class="row mb-1" v-if="!projectPlanning">
            <div class="col-lg-1">
              <select v-model="currentTimeframe">
                <option value="week">Week</option>
                <option value="month">Month</option>
                <option value="quarter">Quarter</option>
                <option value="year">Year</option>
              </select>
            </div>
            <div class="col-lg-2 dropdown project-leads-dropdown">
              <a v-model="selectedProjectLead" class="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true"
                aria-expanded="false">
                {{selectedProjectLead.displayName}}
              </a>
              <div class="dropdown-menu" style="max-height: 300px; overflow-y: scroll;">
                <a class="dropdown-item" v-for="lead in projectLeads" :value="lead.project_lead_id"
                  @click="selectProjectLead(lead)"><i class="fa fa-user"></i> {{lead.displayName}}</a>
              </div>
            </div>
          </div>
          <div class="col-lg-12 table-navigation pl-0 mb-1" v-if="showNavigation">
            <div class="col-lg-10 pl-0">
              <button @click="removeOneWeek">Extra period before</button>
              <button v-if="!projectPlanning" @click="increaseOffset">&larr;</button>
              <button v-if="!projectPlanning" @click="decreaseOffset">&rarr;</button>
              <button @click="addOneWeek">Extra period after</button>
              <label v-if="projectPlanning" class="planning-table-label total-planned-number-all-users">Total
                Planned</label>
              <label v-if="projectPlanning" class="planning-table-label total-user-planned-hours-number">Planned hours
                (all projects)</label>
              <label v-if="projectPlanning" class="planning-table-label expenses-number">Expenses</label>
              <label v-if="projectPlanning" class="planning-table-label logged-number">Logged</label>
            </div>
            <!--<div v-if="projectPlanning" class="col-lg-6">-->
            <!--&lt;!&ndash;<label class="planning-table-label planned-time">Planned time</label>&ndash;&gt;-->
            <!--<label class="planning-table-label total-planned-number-all-users">Total Planned</label>-->
            <!--<label class="planning-table-label total-user-planned-hours-number">Planned hours (all projects)</label>-->
            <!--<label class="planning-table-label expenses-number">Expenses</label>-->
            <!--<label class="planning-table-label logged-number">Logged</label>-->
            <!--</div>-->
          </div>
          <div role="group" class="btn-group btn-group-sm mb-1">
            <button v-if="!projectPlanning" class="btn btn-success" @click="toggleHoursOrExpenses(hoursOrExpenses.type)"
              v-model="hoursOrExpenses"><span
                :class="[hoursOrExpenses.type == 'hours'? 'hours-enabled': '']">Hours</span>/<span
                :class="[hoursOrExpenses.type == 'rates'? 'rates-enabled': '']">Hours*Rate</span></button>
            <!--<button v-if="!projectPlanning" type="button" :class="showHours ? 'btn-success' : 'btn-info'" @click="showHours=!showHours" class="btn">Logged hours</button>-->
            <!--<button v-if="!projectPlanning" type="button" :class="showRateTime ? 'btn-success' : 'btn-info'" @click="showRateTime=!showRateTime" class="btn">Hours * rate</button>-->
            <button v-if="!projectPlanning" type="button" :class="showWorkloadPlanner ? 'btn-success' : 'btn-info'"
              @click="showWorkloadPlanner=!showWorkloadPlanner" class="btn">Workload planner</button>
            <button v-if="!projectPlanning" type="button" :class="showPlannedExpenses ? 'btn-success' : 'btn-info'"
              @click="showPlannedExpenses=!showPlannedExpenses" class="btn">Planned expenses</button>
            <button v-if="!projectPlanning" type="button" :class="showMaterialExpenses ? 'btn-success' : 'btn-info'"
              @click="showMaterialExpenses=!showMaterialExpenses" class="btn">Material expenses</button>
          </div>
          <ProjectCategoryFilter v-if="showFilters" v-model="categoryFilter"></ProjectCategoryFilter>
          <div class="table-view">
            <table class="table table-sm">
              <thead>
                <tr>
                  <td class="first-column">
                    Project
                  </td>
                  <td v-for="date in calendar" class="table-data table-head-th" :class="[
                      isCurrentWeek(date) ? 'curweek' : '',
                      date.index > actualDate ? 'after-curweek' : '',
                      date.index < actualDate ? 'before-curweek' : ''
                  ]">
                    {{date.indexToView}}
                  </td>
                </tr>
                <tr>
                  <td class="first-column"></td>
                  <td v-for="date in calendar" class="table-data table-head-th" :class="[
                      isCurrentWeek(date) ? 'curweek' : '',
                      date.index > actualDate ? 'after-curweek' : '',
                      date.index < actualDate ? 'before-curweek' : ''
                  ]">
                    {{date.string}}
                  </td>
                </tr>
              </thead>

              <template v-for="(logsByCategories, categoryId) in jiraProjectWorklogsArray">
                <tr @click="toggleExtendedCategories(categoryId)" class="border-bottom-2">
                  <td colspan="20"><b>{{ projectCategories[categoryId].name }}</b></td>
                </tr>

                <template v-if="extendedCategories[categoryId] && showProject(projectId)"
                  v-for="(project, projectId) in logsByCategories">
                  <tr @click="toggleExtended(projectId)" class="projectrow first-column">
                    <ProjectCell :projectId="projectId"></ProjectCell>
                    <td v-if="!projectPlanning" v-for="(logged, yearweek) in project.total"
                      :class=" [yearweek == actualDate ? 'curweek' : '', yearweek > actualDate ? 'after-curweek' : '', yearweek < actualDate ? 'before-curweek' : '']"
                      class="table-data">
                      <div v-show="showHours" :class="{'zero-value': !logged.time}">
                        {{numberWithSpaces((logged.time/3600).toFixed(0))}}</div>
                      <div v-show="showRateTime" :class="{'zero-value': !logged.expenses}" class="currency">
                        {{numberWithSpaces((logged.expenses/3600).toFixed(0))}}</div>
                      <div v-show="showWorkloadPlanner || showPlannedExpenses">
                        <span
                          v-show="showWorkloadPlanner">{{numberWithSpaces(((totalWorkloadByProjectOnYearweek[projectId][yearweek].plannedTime
                          + totalWorkloadByProjectOnYearweek[projectId][yearweek].calculatedTime) /
                          3600).toFixed(0))}}</span>
                        <span v-show="showPlannedExpenses"
                          class="currency">{{numberWithSpaces((totalWorkloadByProjectOnYearweek[projectId][yearweek].plannedExpenses
                          / 3600).toFixed(0))}}</span>
                      </div>
                      <div v-show="showMaterialExpenses" class="currency"
                        :class="{'zero-value': !projectMaterialCosts[projectId] || !projectMaterialCosts[projectId][yearweek]}">
                        {{numberWithSpaces((projectMaterialCosts[projectId] && projectMaterialCosts[projectId][yearweek]
                        ? projectMaterialCosts[projectId][yearweek] : 0).toFixed(0))}}
                      </div>
                    </td>
                    <td v-if="projectPlanning" v-for="(logged, yearweek) in project.total"
                      :class=" [yearweek == actualDate ? 'curweek' : '', yearweek > actualDate ? 'after-curweek' : '', yearweek < actualDate ? 'before-curweek' : '']"
                      class="table-data">
                      <!--<div><small>Planned</small></div>-->
                      <div v-if="yearweek < actualDate" class="currency expenses-number">
                        {{numberWithSpaces((logged.expenses/3600 + (projectMaterialCosts[projectId] &&
                        projectMaterialCosts[projectId][yearweek] ? projectMaterialCosts[projectId][yearweek] :
                        0)).toFixed(2))}}</div>
                      <div v-if="yearweek >= actualDate" class="currency expenses-number">
                        {{numberWithSpaces(((totalWorkloadByProjectOnYearweek[projectId][yearweek].plannedExpenses /
                        3600) + (projectMaterialCosts[projectId] && projectMaterialCosts[projectId][yearweek] ?
                        projectMaterialCosts[projectId][yearweek] : 0)).toFixed(2))}}</div>
                      <div>
                        <span v-if="yearweek < actualDate"
                          class="total-planned-number-all-users">{{(logged.time/3600).toFixed(2)}}</span>
                        <span v-if="yearweek >= actualDate" class="total-planned-number-all-users">
                          {{((totalWorkloadByProjectOnYearweek[projectId][yearweek].plannedTime +
                          totalWorkloadByProjectOnYearweek[projectId][yearweek].calculatedTime) / 3600).toFixed(2)}}
                        </span>
                      </div>
                    </td>
                  </tr>
                  <template v-if="extendedProjects[project.project_id]">
                    <UserRow class="project-user" v-for="(log, user) in project.byUser"
                      v-if="(!additionalUsers[project.project_id] || !additionalUsers[project.project_id][user]) && users[user].enabled"
                      :userId="user" :logs="log" :projectId="project.project_id" :key="project.project_id + '_' + user"
                      :showHours="showHours" :showRateTime="showRateTime" :showWorkloadPlanner="showWorkloadPlanner"
                      :showPlannedExpenses="showPlannedExpenses" :showTotalPlanned="showWorkloadPlanner"
                      :allowExpanding="false" :timeframe="currentTimeframe" :projectPlanning="projectPlanning"
                      :plannedWorkloads="plannedWorkloads" :removeOption="removeOption(log, user)">
                    </UserRow>
                    <UserRow class="project-user" v-for="(log, user) in additionalUsers[project.project_id]"
                      :userId="user" :logs="log" :projectId="project.project_id" :key="project.project_id + '_' + user"
                      :showHours="showHours" :showRateTime="showRateTime" :showWorkloadPlanner="showWorkloadPlanner"
                      :showPlannedExpenses="showPlannedExpenses" :showTotalPlanned="showWorkloadPlanner"
                      :allowExpanding="false" :timeframe="currentTimeframe" :projectPlanning="projectPlanning"
                      :plannedWorkloads="plannedWorkloads">
                    </UserRow>
                    <tr class="project-user">
                      <td class="first-column">
                        <select class="" @change="addUser($event, loprojectgs.project_id)">
                          <option value="" selected disabled>Add user to project</option>
                          <option :value="user.id" v-for="user in availableUsers(project.project_id)"
                            v-if="user.active">{{user.displayName}}</option>
                        </select>
                      </td>
                      <td :colspan="calendar.length"></td>
                    </tr>
                    <ProjectMaterialCostsRow class="project-user" v-if="showMaterialExpenses || projectPlanning"
                      v-for="(material, materialId) in projectMaterialsByProject[project.project_id]"
                      :materialId="materialId" :key="materialId" :timeframe="currentTimeframe">
                    </ProjectMaterialCostsRow>
                    <NewProjectMaterialRow class="project-user" v-if="showMaterialExpenses || projectPlanning"
                      :projectId="project.project_id"></NewProjectMaterialRow>
                  </template>
                </template>
              </template>
            </table>
          </div>
          <button class="btn btn-primary mt-1" v-if="projectPlanning" @click="restoreTableData">Update data</button>
        </div>
      </div>
    </div>
    <button @click="showGraph = !showGraph" class="btn btn-info btn-sm">Toggle graph</button>
    <div v-if="!projectPlanning" class="card">
      <div id="eventdrops-demo" style="width: 100%; background: #eee;"></div>
    </div>
    <div class="card" v-if="showGraph">
      <div id="gchart" class="width: 100%">
        <GChart type="AreaChart" :data="chartData"
          :options="{isStacked: true, width: 900, height: 500, focusTarget: 'category'}" />
      </div>
    </div>
  </div>
</template>
<style scoped>
@media only screen and (min-width : 1701px) {
  .table-view {
    max-width: 1400px;
  }
}

@media only screen and (max-width : 1700px) {
  .table-view {
    max-width: 1300px;
  }
}

@media only screen and (max-width : 1600px) {
  .table-view {
    max-width: 1200px;
  }
}

@media only screen and (max-width : 1500px) {
  .table-view {
    max-width: 950px;
  }
}

.table-condensed td {
  padding: 0;
  border-right: 1px solid #cfd8dc;
}

/*.table-view {*/
/*overflow-y: hidden;*/
/*overflow-x: scroll;*/
/*}*/
.table-view {
  overflow: scroll;
  position: relative;
  max-height: 800px;
}

.first-column {
  position: sticky;
  position: -webkit-sticky;
  left: 0;
  z-index: 1;
  background: white;
}

.currency::after {
  content: "€";
}

.expenses-number {
  color: darkgreen;
}

.total-user-planned-hours-number {
  color: blueviolet;
}

.total-planned-number-all-users {
  color: darkorange;
}

.planned-time {
  color: #005ef7;
}

.logged-number {
  color: crimson;
}

.table-head-th {
  min-width: 80px;
}

.curweek {
  /*background-color: #ffffff;*/
  border-left: 3px solid black !important;
}

.before-curweek {
  /*background-color: #ffffff;*/
}

.after-curweek {
  /*background-color: #ffffff;*/
}

.table-data {
  /*text-align: right;*/
}

.zero-value {
  color: silver;
}

.table-navigation {
  display: flex;
}

.planning-table-label {
  margin-top: 5px;
  /*padding-right: 10px;*/
  margin-bottom: 0px;
}
</style>

<script>

import { mapGetters, mapActions, mapState } from 'vuex';
import { GChart } from 'vue-google-charts';
import * as d3 from 'd3';
import eventDrops from 'event-drops';
import moment from 'moment';
import VueNotifications from 'vue-notifications';
import Vue from 'vue';
import ProjectCell from './ProjectCell';
import UserRow from './UserRow';
import NewProjectMaterialRow from './NewProjectMaterialRow';
import ProjectMaterialCostsRow from './ProjectMaterialCostsRow';
import ProjectCategoryFilter from './ProjectCategoryFilter';

export default {
  name: 'ProjectWorklogs',
  components: {
    ProjectCell,
    UserRow,
    ProjectMaterialCostsRow,
    NewProjectMaterialRow,
    GChart,
    ProjectCategoryFilter
  },
  data: () => {
    return {
      extendedProjects: {},
      extendedCategories: {},
      showHours: true,
      showRateTime: false,
      showWorkloadPlanner: false,
      showPlannedExpenses: false,
      showMaterialExpenses: false,
      additionalUsers: {},
      projectFilter: 'all',
      categoryFilter: {},
      showGraph: false,
      loadObject: {
        timeframe: 'week',
        count: 8,
        offset: -3,
        project_id: null
      },
      jiraProjectWorklogsArray: [],
      selectedProjectLead: {
        project_lead_id: '',
        displayName: 'Project leads'
      },
      hoursOrExpenses: {
        type: 'hours',
        name: 'Hours/Hours*rate'
      },
      hours: {
        type: 'hours',
        name: 'Hours'
      },
      expenses: {
        type: 'rates',
        name: 'Hours*rate'
      },
      plannedWorkloads: {},
      dataLoaded: {
        worklogs: false,
        workloads: false,
        projects: false,
      }
    };
  },
  props: {
    projectId: {
      default: '',
    },
    showFilters: {
      default: true,
      type: Boolean,
    },
    showNavigation: {
      default: true,
      type: Boolean,
    },
    projectPlanning: {
      default: false,
      type: Boolean
    }
  },
  watch: {
    'projectPlanning.default': {
      immediate: true,
      handler: function (val) {
        if (this.projectPlanning) {
          Vue.set(this.extendedProjects, this.projectId, true);
          this.showWorkloadPlanner = true;
          this.loadObject.count = 8;
          this.loadObject.offset = -5;
        }
      }
    },
    projectCategories: function () {
      this.setAllCategoriesActive();
    },
    worklogs: {
      handler: function (val) {
        //                    this.jiraProjectWorklogsArray = this.jiraProjectWorklogs();
        this.dataLoaded.worklogs = true;
        this.checkStatus;
      },
      deep: true
    },
    workloads: {
      handler: function (val) {
        this.dataLoaded.workloads = true;
        this.checkStatus;
      },
      deep: true
    },
    projects: {
      handler: function (val) {
        this.dataLoaded.projects = true;
        this.checkStatus;
      },
      deep: true
    },
    workloadNotification: {
      handler: function (val) {
        if (this.workloadNotification.status == 'success') {
          this.showSuccessMsg({ title: 'Remove user from project!', message: this.workloadNotification.message });
          this.restoreTableData();
        }
        if (this.workloadNotification.status == 'error') {
          this.showErrorMsg({
            title: 'Remove user from project!',
            message: this.workloadNotification.message
          });
        }
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters('JiraUsers', ['users', 'activeUsers']),
    ...mapGetters('JiraProjects', ['projects', 'projectCategories', 'projectLeads']),
    ...mapGetters('WorkloadPlans', ['workloadsByProjectByUserByYearweek',
      'workloadsByProjectByUserByMonth',
      'workloadsByProjectByUserByQuarter',
      'workloadsByProjectByUserByYear',
      'workloadsByUserByYearweekByProject',
      'workloads',
      'workloadNotification']),
    ...mapGetters('Worklogs', ['datesByYearweek', 'yearweeksByDate', 'curweek', 'weeks', 'endDate', 'count', 'offset', 'worklogsByCategory', 'worklogsByProject', 'timeframe', 'calendar', 'actualDate', 'worklogs']),
    ...mapGetters('ProjectMaterials', ['projectMaterialsByProject', 'projectMaterialCostsByYearweek', 'projectMaterialCostsByMonth', 'projectMaterialCostsByQuarter', 'projectMaterialCostsByYear']),
    checkStatus() {
      if (this.dataLoaded.worklogs === true && this.dataLoaded.workloads === true && this.dataLoaded.projects === true) {
        this.jiraProjectWorklogsArray = this.jiraProjectWorklogs();

        this.calculateTotalPlanned();
        if (Object.values(this.additionalUsers).length) {
          this.addOrRemoveWeeksToAdditonalUsers();
        }
      }
    },
    worklogWeeks() {
      return this.$store.state.Worklogs.weeks;
    },
    totalWorkloadByProjectOnYearweek() {
      const workloads = {};
      let rawWorkloads; //= this.workloadsByProjectByUserByYearweek;
      switch (this.timeframe) {
        case 'week':
          rawWorkloads = this.workloadsByProjectByUserByYearweek;
          break;
        case 'month':
          rawWorkloads = this.workloadsByProjectByUserByMonth;
          break;
        case 'quarter':
          rawWorkloads = this.workloadsByProjectByUserByQuarter;
          break;
        case 'year':
          rawWorkloads = this.workloadsByProjectByUserByYear;
          break;
      }
      for (var projectId in rawWorkloads) {
        if (!workloads[projectId]) workloads[projectId] = {};
        for (var authorId in rawWorkloads[projectId]) {
          for (var date in rawWorkloads[projectId][authorId]) {
            if (!workloads[projectId][date]) {
              workloads[projectId][date] = {
                plannedTime: 0,
                calculatedTime: 0,
                plannedExpenses: 0
              };
            }
            rawWorkloads[projectId][authorId][date].forEach((workload) => {
              workloads[projectId][date].plannedTime += parseInt(workload.planned_time);
              workloads[projectId][date].calculatedTime += parseInt(workload.calculated_time);
              workloads[projectId][date].plannedExpenses += (parseInt(workload.planned_time) + parseInt(workload.calculated_time)) * this.rateOnDate(workload.date, authorId);
            });
          }
        }
      }
      for (projectId in this.projects) {
        if (!workloads[projectId]) workloads[projectId] = {};
        this.calendar.forEach((week) => {
          if (!workloads[projectId][week.index]) {
            workloads[projectId][week.index] = {
              plannedTime: 0,
              plannedExpenses: 0,
              calculatedTime: 0,
            };
          }
        });
      }
      return workloads;
    },
    chartData() {
      const chartData = [];
      const jiraProjectWorklogs = this.jiraProjectWorklogsArray;
      chartData[0] = [];
      chartData[0][0] = 'Yearweek';
      const weekData = {};

      //                this.weeks.forEach(week => {
      //                    weekData[week.yearweek] = [week.yearweek.toString()];
      //                    weekData[week.yearweek] = [week.yearweek.toString()];
      //                });
      for (const projectId in this.projects) {
        if (this.showProject(projectId)) {
          const project = this.projects[projectId];
          chartData[0].push(project.name);
          for (const i in jiraProjectWorklogs) {
            if (jiraProjectWorklogs[i].project_id == projectId) {
              for (var yearweek in jiraProjectWorklogs[i].total) {
                if (!weekData.hasOwnProperty(yearweek)) {
                  weekData[yearweek] = [yearweek.toString()];
                }
                weekData[yearweek].push(jiraProjectWorklogs[i].total[yearweek].time / 3600);
              }
            }
          }
          //                        for(var yearweek in jiraProjectWorklogs[projectId].total){
          //                            if(!weekData.hasOwnProperty(yearweek)){
          //                                weekData[yearweek] = [yearweek.toString()];
          //                            }
          //                            weekData[yearweek].push(jiraProjectWorklogs[projectId].total[yearweek].time/3600);
          //                        }
        }
      }
      for (var yearweek in weekData) {
        chartData.push(weekData[yearweek]);
      }
      this.createEventDropGraph();
      return chartData;
    },
    currentTimeframe: {
      get() {
        return this.timeframe;
      },
      set(value) {
        this.loadLogs({ timeframe: value, count: 4, offset: 0 });
      }
    },
    projectMaterialCosts: function () {
      let materialCosts = {};
      switch (this.timeframe) {
        case 'week':
          materialCosts = this.projectMaterialCostsByYearweek;
          break;
        case 'month':
          materialCosts = this.projectMaterialCostsByMonth;
          break;
        case 'quarter':
          materialCosts = this.projectMaterialCostsByQuarter;
          break;
        case 'year':
          materialCosts = this.projectMaterialCostsByYear;
          break;
      }
      return materialCosts;
    },
    // projectMaterialsByProject: function(){
    //     var materials = {};
    //     switch(this.timeframe){
    //         case 'week':
    //             materials = this.projectMaterialsByYearweek;
    //             break;
    //         case 'month':
    //             materials = this.projectMaterialsByMonth;
    //             break;
    //         case 'quarter':
    //             materials = this.projectMaterialsByQuarter;
    //             break;
    //         case 'year':
    //             materials = this.projectMaterialsByYear;
    //             break;
    //     }
    //     return materials;
    // }
  },
  methods: {
    ...mapActions({
      loadLogs: 'Worklogs/LOAD_JIRA_WORKLOGS', // map `this.add()` to `this.$store.dispatch('increment')`
      loadSingleProjectLogs: 'Worklogs/LOAD_SINGLE_PROJECT_JIRA_WORKLOGS',
      loadWorkloads: 'WorkloadPlans/LOAD_PLANNED_WORKLOADS',
      loadSingleProjectWorkloads: 'WorkloadPlans/LOAD_PROJECT_PLANNED_WORKLOADS',
      loadProjectMaterials: 'ProjectMaterials/LOAD_PROJECT_MATERIALS',
      loadSingleProjectMaterials: 'ProjectMaterials/LOAD_SINGLE_PROJECT_MATERIALS'
    }),
    restoreTableData() {
      this.jiraProjectWorklogsArray = [];
      this.additionalUsers = {};
      this.dataLoaded = {
        worklogs: false,
        workloads: false,
        projects: false,
      };
      this.loadSingleProjectLogs(this.loadObject);
      this.loadSingleProjectWorkloads({ id: this.projectId });
      this.loadSingleProjectMaterials({ id: this.projectId });
    },
    calculateTotalPlanned() {
      let plannedWorkloads;
      switch (this.timeframe) {
        case 'week':
          plannedWorkloads = this.workloadsByUserByYearweekByProject;
          break;
        case 'month':
          plannedWorkloads = this.workloadsByUserByMonthByProject;
          break;
        case 'quarter':
          plannedWorkloads = this.workloadsByUserByQuarterByProject;
          break;
        case 'year':
          plannedWorkloads = this.workloadsByUserByYearByProject;
          break;
      }
      this.plannedWorkloads = plannedWorkloads;
    },
    jiraProjectWorklogs() {
      const worklogs = JSON.parse(JSON.stringify(this.worklogsByCategory));
      let workloads;

      switch (this.timeframe) {
        case 'week':
          workloads = this.workloadsByProjectByUserByYearweek;
          break;
        case 'month':
          workloads = this.workloadsByProjectByUserByMonth;
          break;
        case 'quarter':
          workloads = this.workloadsByProjectByUserByQuarter;
          break;
        case 'year':
          workloads = this.workloadsByProjectByUserByYear;
          break;
      }
      for (var categoryID in worklogs) {
        for (var projectID in worklogs[categoryID]) {
          if (!worklogs[categoryID][projectID]) {
            worklogs[categoryID][projectID] = {
              byUser: {},
              total: {},
            };
            this.calendar.forEach((date) => {
              worklogs[categoryID][projectID].total[date.index] = {
                time: 0,
                expenses: 0
              };
            });
          }

          for (var userId in workloads[projectID]) {
            if (!worklogs[categoryID][projectID].byUser[userId]) {
              worklogs[categoryID][projectID].byUser[userId] = {
                total: {},
                byProject: {}
              };
              this.calendar.forEach((date) => {
                worklogs[categoryID][projectID].byUser[userId].total[date.index] = {
                  time: 0,
                  expenses: 0
                };
              });
            }
          }
        }
      }

      return worklogs;
    },
    removeOption(log, userId) {
      if (!this.projectPlanning) {
        return false;
      }
      let loggedTime = false;
      for (const i in log.total) {
        if (log.total[i].time != 0) {
          loggedTime = true;
          break;
        }
      }
      if (loggedTime) {
        return false;
      }
      let plannedTime = false;
      if (this.plannedWorkloads[userId]) {
        for (const i in this.plannedWorkloads[userId]) {
          if (i >= this.actualDate) {
            if (this.plannedWorkloads[userId][i].totalCalculated != 0 || this.plannedWorkloads[userId][i].totalPlanned != 0) {
              plannedTime = true;
              break;
            }
          }
        }
        //                console.log('this.plannedWorkloads[userId]', this.plannedWorkloads[userId]);
      }
      if (plannedTime) {
        return false;
      }
      //              console.log('plannedTime', plannedTime);
      return true;
    },
    addOrRemoveWeeksToAdditonalUsers() {
      const additional = JSON.parse(JSON.stringify(this.additionalUsers));
      this.additionalUsers = {};
      for (const i in additional) {
        const project = additional[i];
        for (const user in project) {
          for (const n in this.calendar) {
            if (!project[user].total[this.calendar[n].index]) {
              project[user].total[this.calendar[n].index] = {
                time: 0,
                expenses: 0,
              };
            }
          }
          for (const week in project[user].total) {
            let weekExists = false;
            for (const index in this.calendar) {
              if (week == this.calendar[index].index) {
                weekExists = true;
                break;
              }
            }
            if (!weekExists) {
              delete project[user].total[week];
            }
          }
        }
      }
      this.additionalUsers = additional;
    },
    getProjectWorklogData() {
      this.loadLogs({ weekCount: this.weekCount, weekOffset: this.weekOffset });
    },
    addOneWeek() {
      if (this.projectPlanning) {
        this.loadObject.offset -= 1;
        this.loadObject.count += 1;
        this.loadSingleProjectLogs(this.loadObject);
      } else {
        this.loadLogs({ timeframe: this.timeframe, count: this.count + 1, offset: this.offset });
      }
    },
    increaseOffset() {
      this.loadLogs({ timeframe: this.timeframe, count: this.count, offset: this.offset + 1 });
    },
    decreaseOffset() {
      this.loadLogs({ timeframe: this.timeframe, count: this.count, offset: this.offset - 1 });
    },
    removeOneWeek() {
      if (this.projectPlanning) {
        //                    this.loadObject.offset += 1;
        this.loadObject.count += 1;
        this.loadSingleProjectLogs(this.loadObject);
      } else {
        this.loadLogs({ timeframe: this.timeframe, count: this.count - 1, offset: this.offset });
      }
    },
    toggleExtended(projectId) {
      if (!this.extendedProjects.hasOwnProperty(projectId)) {
        Vue.set(this.extendedProjects, projectId, true);
      } else {
        Vue.set(this.extendedProjects, projectId, !this.extendedProjects[projectId]);
      }
    },
    toggleExtendedCategories(categoryId) {
      if (!this.extendedCategories.hasOwnProperty(categoryId)) {
        Vue.set(this.extendedCategories, categoryId, true);
      } else {
        Vue.set(this.extendedCategories, categoryId, !this.extendedCategories[categoryId]);
      }
    },
    rateOnDate(date, userId) {
      return this.$store.getters['UserRates/ratesOnDate'](date, userId);
    },
    availableUsers(projectId) {
      const users = { ...this.activeUsers };
      //                var rawLogs = this.worklogsByProject[projectId].byUser;
      //                for(var authorId in rawLogs){
      //                    delete users[authorId];
      //                }
      for (const authorId in this.additionalUsers[projectId]) {
        delete users[authorId];
      }
      for (const i in this.jiraProjectWorklogsArray) {
        if (this.jiraProjectWorklogsArray[i].project_id == projectId) {
          for (const k in this.jiraProjectWorklogsArray[i].byUser) {
            delete users[k];
          }
        }
      }
      return users;
    },
    addUser(event, projectId) {
      const userId = event.target.value;
      const addUsers = { ...this.additionalUsers };
      addUsers[projectId] = addUsers[projectId] || {};

      addUsers[projectId][userId] = addUsers[projectId][userId] || {
        total: {},
        byProject: {}
      };

      this.calendar.forEach((week) => {
        addUsers[projectId][userId].total[week.index] = {
          time: 0,
          expenses: 0,
        };
      });
      event.target.value = '';
      this.additionalUsers = addUsers;
    },
    showProject(projectId) {
      if (this.projectId) {
        return this.projectId == projectId;
      }

      const active = this.projects[projectId].start_date
        && (!this.projects[projectId].end_date
          || new Date(this.projects[projectId].end_date) >= new Date(new Date().getFullYear(), 0, 1) // tekoša gada 1 janvāris
          || new Date(this.projects[projectId].change_requests_end_date) >= new Date(new Date().getFullYear(), 0, 1)); // tekoša gada 1 janvāris

      if (this.selectedProjectLead.project_lead_id) {
        if (!this.categoryFilter['active']) {
          if ((this.projects[projectId].end_date
            && this.projects[projectId].end_date >= '2018-01-01'
            && this.projects[projectId].end_date < moment().endOf('year').format('YYYY-MM-DD')) // tekoša gada 31 dec
            || (this.projects[projectId].change_requests_end_date
              && this.projects[projectId].change_requests_end_date >= '2018-01-01'
              && this.projects[projectId].change_requests_end_date <= moment().endOf('year').format('YYYY-MM-DD'))) // tekoša gada 31 dec
          {
            return this.categoryFilter[this.projects[projectId].category_id]
              && this.projects[projectId].project_lead_id == this.selectedProjectLead.project_lead_id;
          }
        } else {
          return active
            && this.categoryFilter[this.projects[projectId].category_id]
            && this.projects[projectId].project_lead_id == this.selectedProjectLead.project_lead_id;
        }
      }

      if (!this.categoryFilter['active']) {
        if ((this.projects[projectId].end_date
          && this.projects[projectId].end_date >= '2018-01-01'
          && this.projects[projectId].end_date < moment().endOf('year').format('YYYY-MM-DD')) // tekoša gada 31 dec
          || (this.projects[projectId].change_requests_end_date
            && this.projects[projectId].change_requests_end_date >= '2018-01-01'
            && this.projects[projectId].change_requests_end_date <= moment().endOf('year').format('YYYY-MM-DD'))) { // tekoša gada 31 dec
          return this.categoryFilter[this.projects[projectId].category_id];
        }
      } else {
        return active && this.categoryFilter[this.projects[projectId].category_id];
      }
    },
    setAllCategoriesActive() {
      for (const categoryId in this.projectCategories) {
        Vue.set(this.categoryFilter, categoryId, true);
      }
      Vue.set(this.categoryFilter, 'active', true);
      Vue.set(this.categoryFilter, null, true);
    },
    isCurrentWeek(date) {
      return date.index == this.actualDate;
    },
    createEventDropGraph() {
      if (this.projectPlanning) {
        return;
      }
      const jiraProjectWorklogs = this.jiraProjectWorklogsArray;
      const loggedHoursChartData = [];
      const colorArray = ['aqua', 'black', 'blue', 'fuchsia', 'gray', 'green',
        'lime', 'maroon', 'navy', 'olive', 'orange', 'purple', 'red',
        'silver', 'teal', 'yellow', '#BA4A00', '#E74C3C', '#2C3E50',
        '#AF7AC5', '#48C9B0', '#7D6608', '#17202A', '#BB8FCE', ''];

      for (const projectId in this.projects) {
        const color = colorArray[Math.floor(Math.random() * colorArray.length)];
        if (this.showProject(projectId)) {
          const project = {
            name: this.projects[projectId].name,
            data: [],
            color: color
          };
          for (const k in jiraProjectWorklogs) {
            if (jiraProjectWorklogs[k].project_id == projectId) {
              for (const yearweek in jiraProjectWorklogs[k].total) {
                if (jiraProjectWorklogs[k].total[yearweek].time / 3600 > 0) {
                  const hoursInWeek = 168;
                  const loggedHoursInWeek = Math.round(jiraProjectWorklogs[k].total[yearweek].time / 1800);
                  const gap = hoursInWeek / loggedHoursInWeek;
                  let date = new Date(jiraProjectWorklogs[k].total[yearweek].firstDayOfWeek);
                  date.setHours(0, 0, 0, 0); // set date hours to 00:00
                  for (let i = 0; i < loggedHoursInWeek; i++) {
                    const projectWeekData = {
                      date: moment(date).format('YYYY/MM/DD, HH:mm:ss'),
                      tooltipValue: jiraProjectWorklogs[k].total[yearweek].time / 3600,
                      yearweek: yearweek,
                      color: color,
                      radius: Math.sqrt(jiraProjectWorklogs[k].total[yearweek].time / 3600) * 0.7,
                      dateFromDateTo: `${moment(jiraProjectWorklogs[k].total[yearweek].firstDayOfWeek).format('YYYY-MM-DD')
                        } - ${moment(jiraProjectWorklogs[k].total[yearweek].lastDayOfWeek).format('YYYY-MM-DD')}`,
                    };
                    date = moment(date).add(gap, 'hours').format('YYYY/MM/DD, HH:mm:ss');
                    project.data.push(projectWeekData);
                  }
                }
              }
              loggedHoursChartData.push(project);
            }
          }
        }
      }

      const tooltip = d3.select('body').append('div').attr('class', 'tooltip').style('opacity', 0);
      const chart = eventDrops({
        d3,
        label: {
          padding: 5,
          text: (d) => d.name,
          width: 200,
        },
        drop: {
          date: (d, index) => new Date(d.date),
          radius: (d, index) => d.radius,
          color: (d, index) => d.color,
          onMouseOver: ('mouseover', function (d) {
            tooltip.transition().duration(200).style('opacity', 1).style('pointer-events', 'auto');
            tooltip.html(`
                                <div style="background: #fff; border: 3px solid #e7e7e7; border-radius: 15px; padding: 5px;">
                                    <p style="margin-bottom: 5px;">Year/Week: ${d.yearweek}</p>
                                    <p style="margin-bottom: 5px;">Hours: ${d.tooltipValue}</p>
                                    <p style="margin-bottom: 5px;">Period: ${d.dateFromDateTo}</p>
                                </div>`)
              .style('left', `${d3.event.pageX - 200}px`)
              .style('top', `${d3.event.pageY + 20}px`);
          }),
          onMouseOut: () => {
            tooltip.transition().duration(500).style('opacity', 0).style('pointer-events', 'none');
          },
        },
        line: {
          height: 40,
          color: (line, index) => line.color,
        },
        range: {
          start: new Date(new Date().getTime() - 3600000 * 24 * 183), // six months ago
          end: new Date(),
        },
        axis: {
          formats: {
            //                            milliseconds: '',
            //                            seconds: '',
            //                            minutes: '',
            //                            hours: '',
            //                            days: '%a %d',
            milliseconds: '%L',
            seconds: ':%S',
            minutes: '%I:%M',
            hours: '%I %p',
            days: '%a %d',
            weeks: '%V',
            months: '%B',
            year: '%Y',
          }
        },
        zoom: false,
      });

      d3.select('#eventdrops-demo').data([loggedHoursChartData]).call(chart);
    },
    selectProjectLead(lead) {
      this.selectedProjectLead = lead;
    },
    toggleHoursOrExpenses(type) {
      if (type == 'hours') {
        this.hoursOrExpenses = this.expenses;
        this.showRateTime = true;
        this.showHours = false;
      } else {
        this.hoursOrExpenses = this.hours;
        this.showRateTime = false;
        this.showHours = true;
      }
    },
    numberWithSpaces(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    },
  },
  notifications: {
    showSuccessMsg: { type: VueNotifications.types.success },
    showInfoMsg: { type: VueNotifications.types.info },
    showWarnMsg: { type: VueNotifications.types.warn },
    showErrorMsg: { type: VueNotifications.types.error }
  },
  mounted() {
    if (this.projectId && this.projectPlanning) {
      this.loadObject.project_id = this.projectId;
      this.loadSingleProjectLogs(this.loadObject);
      //                this.loadLogs(this.loadObject);
      this.loadSingleProjectMaterials({ id: this.projectId });
    } else {
      this.loadWorkloads();
      this.loadProjectMaterials();
      this.loadLogs(this.loadObject);
    }
    //            if(!this.projectId)this.loadWorkloads();
    // this.loadProjectMaterials();
    //            this.loadLogs(this.loadObject);
    //            this.loadLogs(this.loadObject);
  },
  created() {
    this.setAllCategoriesActive();
    this.calculateTotalPlanned();
  }
};

</script>

<style scoped>
.project-user {
  background-color: #f7f7f7;
}

.projectrow:hover {
  /*background-color: #efefef*/
}

.hours-enabled {
  color: red;
}

.rates-enabled {
  color: red;
}
</style>
